jQuery(document).ready(function($) {

    // product specials slider
    if ($(window).width() < 768) {
      $('.specials-product').each(function() {
        $(this).find('.specials-product__card-wrapper').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            variableWidth: true,
            dots: true,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 3000
        });
      });
    }

    // text image carousel       
    $('.text-image-carousel:not(.no-carousel').each(function() {
        var $slider = $(this).find('.text-image-carousel__item-wrapper');
        var $arrow_wrapper = $(this).find('.text-image-carousel__arrow-wrapper');
        var $view_button = $(this).find('.text-image-carousel__button');
        $slider.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            variableWidth: true,
            arrows: true,
            prevArrow: $(this).find('.slick-arrow__prev'),
            nextArrow: $(this).find('.slick-arrow__next'), 
            responsive: [
                {
                  breakpoint: 1080,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1                        
                  }
                },
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: true
                  }
                },                    
                {
                    breakpoint: 576,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      arrows: false,
                      dots: true
                    }
                }
            ]
        });

        // $view_button.on('click', function(e){
        //   e.preventDefault();
        //   $slider.slick('unslick');
        //   $arrow_wrapper.hide();
        //   $view_button.hide();
        // });
    });


    // news slider
    if ($(window).width() < 768) {
      $('section.news').each(function() {
        $(this).find('.news__card-wrapper').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            // centerMode: true,
            // variableWidth: true,
            dots: true,
            arrows: false,
            // autoplay: true,
            // autoplaySpeed: 3000
        });
      });
    }    


    $('.featured-products').each(function(){
      var $slider = $(this).find('.featured-products__slider'),
          $next_btn = $(this).find('.slick-arrow__next'),
          $prev_btn = $(this).find('.slick-arrow__prev');
                
      $slider.slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          variableWidth: true,
          infinite: true,
          prevArrow: $prev_btn,
          nextArrow: $next_btn,
          responsive: [
            {
              breakpoint: 1080,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              }
            },            
              {
                breakpoint: 811,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                }
              },
              {
                  breakpoint: 576,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false
                  }
              }
          ]
      });
    });

    //recent projects block
    $('.recent-projects').each(function(){
      var $slider = $(this).find('.recent-projects__card-wrapper'),
          $next_btn = $(this).find('.slick-arrow__next'),
          $prev_btn = $(this).find('.slick-arrow__prev');
                
      $slider.slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          variableWidth: true,
          infinite: true,
          prevArrow: $prev_btn,
          nextArrow: $next_btn,
          responsive: [
            {
              breakpoint: 1080,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              }
            },            
              {
                breakpoint: 811,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                }
              },
              {
                  breakpoint: 576,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false
                  }
              }
          ]
      });
    }); 

    // Galery project
    $('.gallery_project').each(function(){
      var $slider = $(this).find('.gallery_project__slider'),
          $next_btn = $(this).find('.slick-arrow__next'),
          $prev_btn = $(this).find('.slick-arrow__prev');
                
      $slider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: true,
          infinite: true,
          centerMode: true,
          autoplay: true,
          autoplaySpeed: 4000,
          prevArrow: $prev_btn,
          nextArrow: $next_btn,
          responsive: [
            {
                breakpoint: 576,
                settings: {
                  dots: true,
                  arrows: false
                }
            }
          ]
      });
    }); 


});
  